import { find } from 'lodash'
import axios from 'axios'
import config from '@/config'
// services
import db from '@/services/db'
import user from '@/services/user'
import authService from '@/services/auth'
// helpers
import eventBus from '@/helpers/event-bus'
import { swfApply } from './helpers/simple-workflow'
// import { getCharacterPrecedingCaret } from './helpers/data-source-input'
// hooks helpers
import {
  applyTabs,
  applySubTabs,
  applyWidgets,
  applyWidgetsData,
  applyCustomCode,
  applyComponents,
} from '@/helpers/inherit-apply-methods'
import { auth } from 'firebase'

export default async function() {
  Cookies.set('sidenav-state', 'pinned')

  if (!this.userId) {
    this.$router.push('/auth')
    return
  }

  window.$setCurrentTab = this.setCurrentTab.bind(this)

  this.$store.commit('setCurrentDash', this.$route.params.id)
  this.$store.commit('setDashboardLoadingStatus', true)

  const getTemplateData = async () => {
    // get list of dashboards that marked as a template
    this.templateDashboardsList = await db.dashboards.getTemplateDashboardsList()
    this.selectedTemplates = await db.dashboards.getSelectedTemplates()

    const inheritedData = {}
    const templatesQueue = ['core']
      .concat(this.selectedTemplates)
      .map(template => {
        if (
          template !== 'core' &&
          !this.templateDashboardsList.includes(template)
        ) {
          console.error(
            `[Inherit Template] - template "${template}" doesn't exist in template list`
          )
          return
        }

        return {
          name: template,
          promise: new Promise(resolve => {
            db.root
              .ref('dashboards')
              .child(template)
              .once('value', snapshot => {
                inheritedData[template] = snapshot.val()

                if (inheritedData[template]) {
                  for (let tabKey in inheritedData[template].tabs) {
                    inheritedData[template].tabs[tabKey].template = template
                  }
                }

                resolve()
              })
          }),
        }
      })

    await new Promise(resolve => {
      this.$loadingQueue(templatesQueue, () => {
        resolve()
      })
    })

    this.inheritedData = inheritedData
  }

  const applyData = (type, data) => {
    switch (type) {
      case 'tabs':
        applyTabs.bind(this)(data)
        break
      case 'subTabs':
        applySubTabs.bind(this)(data)
        break
      case 'widgets':
        applyWidgets.bind(this)(data)
        break
      case 'widgetsData':
        applyWidgetsData.bind(this)(data)
        break
      case 'customCode':
        applyCustomCode.bind(this)(data)
        break
      case 'components':
        applyComponents.bind(this)(data)
        break
    }
  }

  await getTemplateData()

  const queue = [
    {
      name: 'dashAccess',
      promise: new Promise(rootResolve => {
        // read current dashboard access rules for current user
        db.access.dashboard(this.userId, this.currentDash, async actions => {
          const hw = await new Promise(resolve => {
            db.getRef('workspaceAccess').once('value', snapshot => {
              resolve(snapshot.val())
            })
          })
          const hor = await new Promise(resolve => {
            db.root.ref('openRegistration').once('value', snapshot => {
              resolve(snapshot.val())
            })
          })
          if (!hw && !actions && !hor) {
            console.log('redirect user to home from dashboard code')
            document.location = '/home'
          }

          let rule = this.$buildACLRule(
            'Dashboard_' + this.currentDash,
            actions
          )
          this.$store.commit('updateCaslRules', rule)

          rootResolve()
        })
      }),
    },
    {
      name: 'publicDashboards',
      promise: new Promise(resolve => {
        // read public dashboards and compare them to current one
        db.root.ref('publicDashboards').once('value', snapshot => {
          if (this.isNFLApp) {
            resolve()
            return
          }

          const publicDashs = snapshot.val()

          if (publicDashs && publicDashs[this.currentDash]) {
            this.isPublic = true
          } else {
            if (this.userId) {
              resolve()
              return
            }

            localStorate.setItem('lastDash', this.currentDash)
            window.lastDash = this.currentDash
            console.log('set dash and workspace and send user to login page')
            this.$router.push('/auth')
          }
          resolve()
        })
      }),
    },
    {
      name: 'workspaces',
      promise: new Promise(resolve => {
        // read workspaces
        db.getRef('workspaceAccess')
          .once('value')
          .then(snapshot => {
            if (snapshot.val()) {
              if (localStorage.workspace) {
                resolve()
              } else {
                console.log('send user to workspace select')
                this.$router.push(`/dashboard/${this.currentDash}/workspaces`)
              }
            } else {
              console.log('ws access empty')
              resolve()
            }
          })
          .catch(err => {
            console.error(err)
            resolve()
          })
      }),
    },
    {
      name: 'workspacesData1',
      promise: new Promise(resolve => {
        if (localStorage.workspace && fbUser) {
          //get the workspace access data
          console.log('save access data')
          db.accessRef
            .child('workspaceAccess/')
            .orderByChild('email')
            .equalTo(window.fbUser.email)
            .once('value')
            .then(function(snapshot) {
              if (snapshot.val()) {
                var wsa = snapshot.val()

                Object.keys(wsa).forEach(function(key) {
                  if (wsa[key].id == localStorage.workspace) {
                    fbUser.accessData = wsa[key]
                  }
                })
              }
              return
            })

          // read workspace data
          db.root.ref(`access/workspaces/${localStorage.workspace}/data`).on(
            'value',
            snapshot => {
              this.$store.commit('setWorkspaceModels', snapshot.val())
              resolve()
            },
            err => {
              console.log('permission error accessing workspace')
              // console.error(err)
              resolve()
            }
          )
        } else {
          resolve()
        }
      }),
    },
    {
      name: 'workspacesData2',
      promise: new Promise(resolve => {
        if (localStorage.workspace && this.userId) {
          // check users access to workspace and set its name and other props
          db.root.ref(`access/workspaces/${localStorage.workspace}`).once(
            'value',
            snapshot => {
              var wsData = snapshot.val()

              if (wsData) {
                //localStorage.workspaceName = wsData.name
                window.fbUser.workspace = localStorage.workspace
                //window.fbUser.workspaceName = wsData.name
                fbUser.wsData = wsData
                resolve()
              } else {
                localStorage.removeItem('workspace')
                localStorage.removeItem('workspaceName')
                console.log(
                  'user has no access to workspace on this dash send to auth'
                )

                this.$router.push(`/dashboard/${this.currentDash}/workspaces`)
              }
            },
            err => {
              localStorage.removeItem('workspace')
              localStorage.removeItem('workspaceName')
              console.log('workspace error clear workspace')

              this.$router.push(`/dashboard/${this.currentDash}/workspaces`)
              console.error(err)
            }
          )
        } else {
          resolve()
        }
      }),
    },
    {
      name: 'tabOnLoad',
      promise: new Promise(resolve => {
        // read tab id that have to be chosen on page loaded
        db.getRef('tabOnLoad').on('value', snapshot => {
          console.log('tab on load')
          this.tabOnLoad = snapshot.val()
          resolve()
        })
      }),
    },
    {
      name: 'privateTabs',
      promise: new Promise(resolve => {
        // read privet tab ids
        db.getRef('privateTabs').on('value', snapshot => {
          this.privateTabs = snapshot.val() || []
          resolve()
        })
      }),
    },
    {
      name: 'tabs',
      promise: new Promise(resolve => {
        // read tabs for current dashboard
        db.tabs.read(tabs => {
          applyData('tabs', tabs)

          resolve()
        })
      }),
    },
    {
      name: 'subTabs',
      promise: new Promise(resolve => {
        db.tabs.readSubTabs(subTabs => {
          applyData('subTabs', subTabs)

          resolve()
        })
      }),
    },
    {
      name: 'getOwner',
      promise: new Promise(resolve => {
        // check if current user is owner of the dashboard
        db.dashboards.getOwner(owner => {
          if (this.userId === owner) {
            this.$store.commit('setDashOwner', this.userId)
          }
          resolve()
        })
      }),
    },
    {
      name: 'getTitle',
      promise: new Promise(resolve => {
        db.dashboards.getTitle(title => {
          this.dashTitle = title
          document.title = title
          resolve()
        })
      }),
    },
    {
      name: 'widgets',
      promise: new Promise(resolve => {
        // read widgets for current dashboard
        db.widgets.read(widgets => {
          applyData('widgets', widgets)

          resolve()
        })
      }),
    },
    {
      name: 'widgetsData',
      promise: new Promise(resolve => {
        // read data for widgets
        db.widgets.readData(widgetsData => {
          applyData('widgetsData', widgetsData)

          resolve()
        })
      }),
    },
    {
      name: 'widgetsComputed',
      promise: new Promise(resolve => {
        // read computed properties
        db.widgets.readComputed(widgetsComputed => {
          this.widgetsComputed = widgetsComputed || {}
          this.$store.commit('setComputedProps', widgetsComputed)

          this.cacheDashboardSheets()
          resolve()
        })
      }),
    },
    {
      name: 'customCode',
      promise: new Promise(resolve => {
        // read custom code
        db.customCode.read(customCode => {
          applyData('customCode', customCode)

          resolve()
        })
      }),
    },
    {
      name: 'components',
      promise: new Promise(resolve => {
        // read custom components
        db.components.read(components => {
          applyData('components', components)

          resolve()
        })
      }),
    },
    {
      name: 'commonSettings',
      promise: new Promise(resolve => {
        // read settings
        db.settings.read(this.currentDash, settings => {
          this.$nextTick(() => {
            this.$store.commit('setSettings', settings || {})
          })
          resolve()
        })
      }),
    },
    {
      name: 'dashboardSettings',
      promise: new Promise(resolve => {
        // read dashboard settings
        db.settings.readDashboardSettings(settings => {
          this.$store.commit('dashboardSettings_set', settings)
          resolve()
        })
      }),
    },
    {
      name: 'pivottables',
      promise: new Promise(resolve => {
        db.getRef('widgetsData/pivottables').once('value', snapshot => {
          this.$store.commit('setPivotGridOptions', snapshot.val() || {})
          resolve()
        })
      }),
    },
    {
      name: 'navPlacement',
      promise: new Promise(resolve => {
        // read privet tab ids
        db.getRef('navPlacement').on('value', snapshot => {
          this.navPlacement = snapshot.val() || 'sidebar'
          resolve()
        })
      }),
    },
    // {
    //   name: 'dashboardModels',
    //   promise: new Promise((resolve) => {
    //     db.dashboardModels.read().then(data => {
    //       this.$store.commit('setDashboardModels', data)
    //       resolve()
    //     })
    //   })
    // },
    {
      name: 'models_getDashboardModel',
      promise: new Promise(resolve => {
        this.$store.dispatch('models_getDashboardModel', function() {
          resolve()
        })
      }),
    },
    {
      name: 'getFileUrls',
      promise: new Promise(resolve => {
        this.$store.dispatch('getFileUrls', function() {
          resolve()
        })
      }),
    },
    {
      name: 'getUserList',
      promise: new Promise(resolve => {
        user.getUserList().then(allUsers => {
          db.dashboards.getUsers(dashUsers => {
            const users = []

            for (let user of dashUsers) {
              const dashUser = find(allUsers, { uid: user })

              if (dashUser) users.push(dashUser)
            }

            this.$store.commit('setUserList', users)
            this.$store.commit('setUserListAll', allUsers)

            resolve()
          })
        })
      }),
    },
    {
      name: 'getSelectedTemplates',
      promise: new Promise(resolve => {
        db.getRef('templatesInUse').on('value', snapshot => {
          this.$store.commit(
            'templateDash_setDashboardsInUse',
            Object.keys(snapshot.val() || {})
          )
          resolve()
        })
      }),
    },
  ]

  if (this.isNFLApp) {
    queue.push(
      {
        name: 'getProfilesInfo',
        promise: new Promise(resolve => {
          // read profiles info if nfl app
          db.getProfilesInfo(info => {
            if (this.$canUpdate) {
              this.$store.commit('setProfilesInfo', info || {})
            }
            resolve()
          })
        }),
      },
      {
        name: 'getProfileInfo',
        promise: new Promise(resolve => {
          // read profile info for current user
          db.getProfileInfo(this.userId, info => {
            this.$store.commit('setProfileInfo', info || {})
            resolve()
          })
        }),
      },
      {
        name: 'getNFLPAUserData',
        promise: new Promise(resolve => {
          // get user data fetched from nfl api
          const id = this.$profile.websiteId
          db.getNFLPAUserData(id, (err, data) => {
            if (err || !data) {
              this.$router.push('/forbidden/nf')
            } else {
              this.$store.commit('setNFLData', data)

              resolve()
            }
          })
        }),
      }
    )
  }

  this.$loadingQueue(queue, () => {
    if (this.inheritedData.core) {
      for (let template in this.inheritedData) {
        this.$extractDataForInheritedLockedDataGrids(
          template,
          this.inheritedData
        )
      }
    }

    this.isDataLoaded = true

    const tab = this.$route.query.tab
    const subTab = this.$route.query.subtab

    if (tab) this.setCurrentTab(tab)
    else this.setInitialTab()

    if (subTab) this.setCurrentSubTab(subTab)
  })

  // read comments
  this.$store.dispatch('loadComments')
  // read simple workflow
  this.$store.dispatch('simpleWorkflow_read', workflows => {
    // apply appropriate simple workflow events
    swfApply(workflows)
  })

  db.comments
    .getRef()
    .limitToLast(1)
    .on('child_added', snapshot => {
      const comment = snapshot.val()
      comment.id = snapshot.key
      const comments = { [snapshot.key]: comment }
      this.$store.commit('updateComments', comments)
    })

  const functionsUrl = config.midServer[process.env.APP_CONF.instance]

  axios.get(functionsUrl + '/dataGrid_getGroupPermissions', {
    params: {
      authToken: await authService.getIdToken(),
      currentDash: this.currentDash,
    }
  }).then(res => {
    const { groupPermissions } = res.data

    if (!groupPermissions?.needToGroup) {
      db.getRef('dataGridLogs')
        .limitToLast(1)
        .on('child_added', this.dataGridLogCB)
    } else {
      db.getRef('dataGridLogs')
        .orderByChild('group')
        .equalTo(groupPermissions.group)
        .limitToLast(1)
        .on('child_added', this.dataGridLogCB)

      db.getRef('dataGridLogs')
        .orderByChild('group')
        .equalTo(false)
        .limitToLast(1)
        .on('child_added', this.dataGridLogCB)
    }
  })

  // if is not public
  if (!this.isPublic) {
    // read user models
    db.widgets.getUserModels(this.userId, data => {
      this.$store.commit('setFBUserModels', data)
    })
    // read track models
    db.getTrackModels(data => {
      this.$store.commit('setFBTrackModels', data)
    })
  }

  eventBus.$on('showSearchBar', type => {
    this.codeSearchShown[type] = true
  })
  eventBus.$on('hideSearchBar', type => {
    this.codeSearchShown[type] = false
  })
  eventBus.$on('onBefore_inheritedTemplateAdded', () => {
    this.$store.commit('setDashboardLoadingStatus', true)
    this.isDataLoaded = false
  })
  eventBus.$on('on_inheritedTemplateAdded', async () => {
    await getTemplateData()

    const queue = [
      {
        name: 'tabs',
        promise: new Promise(resolve => {
          // read tabs for current dashboard
          db.tabs.read(tabs => {
            applyData('tabs', tabs)

            resolve()
          }, true)
        }),
      },
      {
        name: 'subTabs',
        promise: new Promise(resolve => {
          db.tabs.readSubTabs(subTabs => {
            applyData('subTabs', subTabs)

            resolve()
          }, true)
        }),
      },
      {
        name: 'widgets',
        promise: new Promise(resolve => {
          // read widgets for current dashboard
          db.widgets.read(widgets => {
            applyData('widgets', widgets)

            resolve()
          }, true)
        }),
      },
      {
        name: 'widgetsData',
        promise: new Promise(resolve => {
          // read data for widgets
          db.widgets.readData(widgetsData => {
            applyData('widgetsData', widgetsData)

            resolve()
          }, true)
        }),
      },
      {
        name: 'customCode',
        promise: new Promise(resolve => {
          // read custom code
          db.customCode.read(customCode => {
            applyData('customCode', customCode)

            resolve()
          }, true)
        }),
      },
      {
        name: 'components',
        promise: new Promise(resolve => {
          // read custom components
          db.components.read(components => {
            applyData('components', components)

            resolve()
          }, true)
        }),
      },
    ]

    this.$loadingQueue(queue, () => {
      this.isDataLoaded = true
      this.setCurrentTab(this.currentTab)

      setTimeout(() => {
        this.$store.commit('setDashboardLoadingStatus', false)
      }, 600)
    })
  })

  db.workflow.read(items => {
    if (items) {
      Object.keys(items).forEach(el => {
        let data
        try {
          data = JSON.parse(items[el].data)
        } catch (e) {
          data = []
        }
        this.$store.commit('setWorkflows', {
          id: el,
          data: data,
          name: items[el].name,
        })
      })
    }
  })

  // watch cell change and run onChange code if represetnted
  eventBus.$on('dgCellChanged', (gridId, rowKey, cellKey) => {
    const code = this.dataGrid_options[gridId].meta[cellKey].onChange
    if (!code) return
    console.log('datagrid change')
    this.onDGCellValueChangeCode = `
      <script>
        var $gridId = '${gridId}';
        var $rowKey = '${rowKey}';
        var $cellKey = '${cellKey}';
        var $dg = $getGrid('${gridId}');
        var $dgRow = $getGrid('${gridId}')['${rowKey}'];
        var rowData = _.find($getDataGridVals($dg), { rowKey: '${rowKey}' });
        var row = rowData

        (function () {
          ${code}
        })()
      <\/script>
    `

    this.$nextTick(() => {
      this.onDGCellValueChangeCode = null
    })
  })

  // watch lookup added and add selected datagrid instance if user selected to add it
  eventBus.$on('addDataGridInstance', data => {
    db.dataGrid.data.addColumn(Object.assign({ pasteInNewRow: true }, data))
  })

  // models
  window.$setDashboardModel = db.dashboardModels.setDashboardModel
  window.$getDashboardModel = model => {
    const models_dashboardModel = this.models_dashboardModel

    try {
      let val = eval(`models_dashboardModel.${model}`) // eslint-disable-line
      if (val === undefined) throw new Error()
      return val
    } catch (err) {
      return null
    }
  }
  window.$addDashboardModel = db.dashboardModels.addDashboardModel

  // DataGrid API methods and Event Handlers
  window.$getRawDataGridVal = this.$getRawDataGridVal.bind(this)
  window.$setDataGridVal = db.dataGrid.data.setDataGridVal()
  window.$getDataGridVals = vals => vals
  window.$getDataGridVal = val => val
  window.$dataGrid = this.$store.getters.$dataGrid
  window.$getGrid = this.$store.getters.$getGrid
  window.$dgSetRow = db.dataGrid.data.saveRowData
  // opens edit model
  window.$dgShowEditRowModal = (gridId, rowKey) => {
    this.$refs.dgEditRowModal.open(gridId, rowKey)
  }
  // add new row to DataGrid
  window.$dgAddRow = db.dataGrid.data.addRow
  window.$dgRemoveRow = db.dataGrid.data.removeRow
  eventBus.$on('dataGridAdded', async gridId => {
    const defaultCols = [
      {
        type: 'string',
        gridId,
        displayName: 'Name',
        propertyName: 'name',
      },
      {
        type: 'string',
        gridId,
        displayName: 'State',
        propertyName: 'state',
      },
      {
        type: 'string',
        gridId,
        displayName: 'Next Events',
        propertyName: 'nextEvents',
      },
    ]

    for (let columnData of defaultCols) {
      await db.dataGrid.data.addColumn(columnData)
    }
  })

  // simple workflow
  window.$btnClick = item => {
    eventBus.$emit(`simpleWorkflow-btnClicked-${item.gridId}`, item)
  }

  // const watchDataSourceInput = event => {
  //   if (getCharacterPrecedingCaret(event.target) == '{{') {
  //     // element object
  //     const el = event.target
  //     // cursor position
  //     const start = $(el).prop('selectionStart')
  //     const line = el.value
  //       ? el.value.substr(0, el.selectionStart).split('\n').length
  //       : $(el).html().substr(0, el.selectionStart).split('\n').length

  //     // call data select menu
  //     eventBus.$emit('showDataSelect', { event, el, curPos: { start, line } })
  //   }
  // }

  // $(document).off('input', 'input, textarea, *[contenteditable="true"]')
  // $(document).on(
  //   'input',
  //   'input, textarea, *[contenteditable="true"]',
  //   watchDataSourceInput
  // )

  // additional view
  eventBus.$on('showSimpleWorkflow', () => {
    this.additionalView = 'simpleWorkflow'
  })
  eventBus.$on('showWorkflow', (key) => {
    if (key) {
      this.additionalView = 'workflow'

      this.$nextTick(() => {
        this.$refs.workflow.workflowKey = null
  
        setTimeout(() => {
          this.$refs.workflow.workflowKey = key
        }, 100)
      })
    } else {
      this.additionalView = null
    }
  })
}
